import { render, staticRenderFns } from "./JobLeader.vue?vue&type=template&id=dd1e320c&scoped=true"
import script from "./JobLeader.vue?vue&type=script&lang=js"
export * from "./JobLeader.vue?vue&type=script&lang=js"
import style0 from "./JobLeader.vue?vue&type=style&index=0&id=dd1e320c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1e320c",
  null
  
)

export default component.exports